module.exports = __webpack_public_path__ + "img/pin-mobile.07a40867.svg";